import React from 'react'

export const CharAbs = (props) => { 
    const { item } = props;
    return (
        (item?.boardSrc)&&<div className="charWrapper" style={{zIndex:item.index}}>
            <img alt="personaje" src={item.boardSrc} />
        </div>
    )
}

export default CharAbs;